import React from 'react';
import { Box, ButtonV2, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { JoyAi } from '@withjoy/joykit/icons';
import { useLocation, useTranslation } from '@shared/core';
import { useFeatureFlagsContext } from '@shared/core/featureFlags';

export const VenueError = () => {
  const { t } = useTranslation('websiteEditor');
  const venueErrorTrans = t('venueError');
  const location = useLocation();
  const { formatToUrl } = useFeatureFlagsContext();
  return (
    <Flex
      flex={1}
      flexDirection="column"
      gap={8}
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
      <Flex
        flexDirection="column"
        gap={5}
        alignItems="center"
        maxWidth={{ _: '100%', sm2: pxToRem(410) }}
        paddingX={{ _: 6, sm2: 0 }}
        paddingTop={{ _: 6, sm2: 0 }}
      >
        <JoyAi size={64} />
        <Box
          typographyVariant="hed6"
          fontSize={pxToRem(26)}
          textAlign="center"
        >
          {venueErrorTrans.title()}
        </Box>
        <Box
          typographyVariant="body3"
          textAlign="center"
          maxWidth={pxToRem(362)}
          fontSize={pxToRem(16)}
          color="mono12"
        >
          {venueErrorTrans.message()}
        </Box>
      </Flex>

      <Flex
        width="100%"
        position={{ _: 'sticky', sm2: 'relative' }}
        bottom={0}
        maxWidth={{ _: '100%', sm2: pxToRem(340) }}
        flexDirection="column"
        justifyContent="center"
        borderTop={{ _: '1px solid', sm2: 'none' }}
        borderTopColor="mono3"
        paddingX={{ _: 6, sm2: 0 }}
        paddingY={{ _: 5, sm2: 0 }}
        backgroundColor="white"
        gap={5}
      >
        <ButtonV2
          typographyVariant="button2"
          backgroundColor="newUITest1"
          textAlign="center"
          shape="rounded"
          width={pxToRem(340)}
          as="a"
          href={formatToUrl(location.pathname)}
        >
          {venueErrorTrans.cta()}
        </ButtonV2>
      </Flex>
    </Flex>
  );
};
